<template>
  <a-popover
    v-model="isFocus"
    trigger="focus"
    :title="isObject ? '目标 · 权重说明': '关键结果 · 权重说明'"
    placement="topLeft"
    overlay-class-name="weight__popover"
  >
    <template slot="content">
      {{ isObject ? "单个目标权重不可小于10%，各目标总和需等于100%" : "单个关键结果权重不可小于10%，同目标下的权重总和需等于100% " }}
    </template>
    <div class="weight">
      <div class="weight__label">
        权重%
      </div>
      <a-input
        class="weight__input"
        :class="isError ? 'wrongBox':''"
        placeholder="0"
        pattern="[0-9]*"
        :value="value || null"
        @change="handleInputChange"
        @focus="showTips"
        @blur="hideTips"
      />
    </div>
  </a-popover>
</template>

<script>
import Vue from 'vue'
import { Input, Popover } from 'ant-design-vue'

Vue.use(Input)
Vue.use(Popover)

// 权重组件
export default {
  name: 'Weight',
  components: {},
  props: {
    value: {
      type: Number,
      default: 0,
    },
    // 允许输入的最小值
    min: {
      type: Number,
      default: 0,
    },
    // 允许输入的最大值
    max: {
      type: Number,
      default: 100,
    },
    isObject: {
      type: Boolean,
      default: false,
    },
    isError: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isFocus: false,
    }
  },
  computed: {},
  watch: {},
  methods: {
    /**
     * Input change 事件
     * @param {Object} e 原生 input change 事件 payload
     */
    handleInputChange(e) {
      let v = +e.target.value

      if (isNaN(v)) {
        // 如果输入的不是数字就不提交事件
        return
      }
      const { min, max } = this

      if (v > max) {
        v = max
      } else if (v < min) {
        v = min
      }

      this.$emit('change', v)
    },
    // 显示隐藏气泡提示框
    showTips() {
      this.isFocus = true
      if (this.isError) {
        this.$emit('myFocus')
      }
    },
    hideTips() {
      this.isFocus = false
    },
  },
}
</script>

<style lang="less">
@import '~@assets/style/variables.less';

@borderRadius: 4px;

.weight {
  min-width: 80px;
  width: 80px;
  background: @white;
  text-align: center;
  border-radius: @borderRadius;

  &__label,
  &__input {
    height: 40px;
    line-height: 40px;
  }

  &__label {
    font-weight: 500;
    border: 1px solid rgba(0,0,0,0.15);
    border-bottom: none;
    border-radius: @borderRadius @borderRadius 0 0;
  }

  &__input {
    text-align: center;

    border-radius: 0 0 @borderRadius @borderRadius;
  }

  &__tooltip {
    .ant-tooltip-arrow {
      border-bottom-color: @white;
    }

    .ant-tooltip-inner {
      padding: 0 16px;
      line-height: 32px;

      color: @black;
      background: @white;
    }
  }
  &__popover{width:256px;}
}
</style>
